import utils from "modules/utils"

export default function Icon({
  name,
  size = 22,
  color = "#ffffff",
  bg = false,
  bgColor = null,
  style,
  onClick,
}) {
  const bgFill = bgColor || utils.setColorOpacity(color, 0.2)

  return (
    <svg
      width={size}
      height={size}
      version="1.1"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      {bg === "circle" && <circle cx="11" cy="11" r="11" fill={bgFill} />}
      {bg === "square" && <rect width="22" height="22" x="6" fill={bgFill} />}
      <use
        xlinkHref={`#icons_${name.toLowerCase()}`}
        fill={color}
        x={bg ? 4 : 0}
        y={bg ? 4 : 0}
        width={bg ? 14 : 22}
        height={bg ? 14 : 22}
      />
    </svg>
  )
}
